var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-dialog',{staticClass:"screen-dialog",attrs:{"visible":_vm.showFlag,"showClose":true,"close-on-click-modal":false,"custom-class":_vm.DialogClass,"title":_vm.title,"size":_vm.size},on:{"update:visible":function($event){_vm.showFlag=$event},"visible-change":_vm.closeDialog}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }